export default __webpack_public_path__ + "static/media/PAVILLON BLEU.f18ff9d2.svg";